import { useTransportMutation } from "@/transport"

/** Runs a draft Custom SQL metric against recent workspace simulations. It stays a mutation because testing is explicitly triggered, while authoring failures arrive in a successful response and only transport failures become mutation errors. */
export function useTestSqlMetricTransport() {
  return useTransportMutation("testSqlMetric", { reportErrors: false })
}
